import { vars } from '../base/variables'
import { menuToggle } from '../functions/menu-toggle'

export default () => {
	const toggleBtn = document.querySelector('.menu-toggle')
	menuToggle(toggleBtn, vars.body[0])
}